import React, {  useState, useRef, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import '../../Zone/zone.css';
import '../../Zone/musicposter.css';

function Music() {
  const navigate = useNavigate();
  const [selectedTrack, setSelectedTrack] = useState(null);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const audioRef = useRef(null);

const tracks = [
  { id: 1, title: 'Daivathinte Kaiyil Nammude Naal.mp3', audio: '/music/music/m1.mp3', musicposter: '/music/musicposter/m1.webp' },
  { id: 2, title: 'Dakshina Deepam.mp3', audio: '/music/music/m2.mp3', musicposter: '/music/musicposter/m2.webp' },
  { id: 3, title: 'Yenapps Style.mp3', audio: '/music/music/m3.mp3', musicposter: '/music/musicposter/m3.webp' },
  { id: 4, title: 'Do aur Do panch chalo.mp3', audio: '/music/music/m4.mp3', musicposter: '/music/musicposter/m4.webp' },
  { id: 5, title: 'Ahankar Panch Chor.mp3', audio: '/music/music/m5.mp3', musicposter: '/music/musicposter/m5.webp' },
  { id: 6, title: 'Ashtha Bhuja Shakti.mp3', audio: '/music/music/m6.mp3', musicposter: '/music/musicposter/m6.webp' },
  { id: 7, title: 'India- The VishWaguru Rise.mp3', audio: '/music/music/m7.mp3', musicposter: '/music/musicposter/m7.webp' },
  { id: 8, title: 'Jagannath He Kalki Re.mp3', audio: '/music/music/m8.mp3', musicposter: '/music/musicposter/m8.webp' },
  { id: 9, title: 'Mujh Main Bus Heer Re.mp3', audio: '/music/music/m9.mp3', musicposter: '/music/musicposter/m9.webp' },
  { id: 10, title: 'Prem Ka Panch Pandav.mp3', audio: '/music/music/m10.mp3', musicposter: '/music/musicposter/m10.webp' },
  { id: 11, title: 'Rulewale Raja Ke.mp3', audio: '/music/music/m11.mp3', musicposter: '/music/musicposter/m11.webp' },
  { id: 12, title: 'Sabka Rasta Ek hi baap re.mp3', audio: '/music/music/m12.mp3', musicposter: '/music/musicposter/m12.webp' },
  { id: 13, title: 'Shantini Premachavya.mp3', audio: '/music/music/m13.mp3', musicposter: '/music/musicposter/m13.webp' },
  { id: 14, title: 'Tere Prem De Rangilo.mp3', audio: '/music/music/m14.mp3', musicposter: '/music/musicposter/m14.webp' },
  { id: 15, title: 'The Land That Called My Name.mp3', audio: '/music/music/m15.mp3', musicposter: '/music/musicposter/m15.webp' },
  { id: 16, title: 'VishwaGuru Banega India.mp3', audio: '/music/music/m16.mp3', musicposter: '/music/musicposter/m16.webp' },
  { id: 17, title: 'Chaya ka saudagar rahu ketu.mp3', audio: '/music/music/m17.mp3', musicposter: '/music/musicposter/m17.webp' },
  { id: 18, title: 'Pyar Ka Full Toss.mp3', audio: '/music/music/m18.mp3', musicposter: '/music/musicposter/m18.webp' },
  { id: 19, title: 'Sanatan To AI_DHARMA.mp3', audio: '/music/music/m19.mp3', musicposter: '/music/musicposter/m19.webp' },
  { id: 20, title: 'Main Bhatka the...Kalki ne Jagaya.mp3', audio: '/music/music/m20.mp3', musicposter: '/music/musicposter/m20.webp' },
  { id: 21, title: 'Banega Dharma Karma Yogi.mp3', audio: '/music/music/m21.mp3', musicposter: '/music/musicposter/m21.webp' },
  { id: 22, title: 'Khuda Mere Dil Main Hai.mp3', audio: '/music/music/m22.mp3', musicposter: '/music/musicposter/m22.webp' },
  { id: 23, title: 'Paise Pe Pinga.mp3', audio: '/music/music/m23.mp3', musicposter: '/music/musicposter/m23.webp' },
  { id: 24, title: 'Sambar Sanskar.mp3', audio: '/music/music/m24.mp3', musicposter: '/music/musicposter/m24.webp' },
  { id: 25, title: 'Eternal Flow.mp3', audio: '/music/music/m25.mp3', musicposter: '/music/musicposter/m25.webp' },
  { id: 26, title: 'Unity Vibes.mp3', audio: '/music/music/m26.mp3', musicposter: '/music/musicposter/m26.webp' },
  { id: 27, title: 'Ye Soul U Double Acting.mp3', audio: '/music/music/m27.mp3', musicposter: '/music/musicposter/m27.webp' },
  { id: 28, title: 'Te Punha Ubhi Rahili.mp3', audio: '/music/music/m28.mp3', musicposter: '/music/musicposter/m28.webp' },
  { id: 29, title: 'Namak Ki Daag.mp3', audio: '/music/music/m29.mp3', musicposter: '/music/musicposter/m29.webp' },
  { id: 30, title: 'Main Sanatan Hun.mp3', audio: '/music/music/m30.mp3', musicposter: '/music/musicposter/m30.webp' },
  { id: 31, title: 'Ram Ram Krishna Kalki Kalki.mp3', audio: '/music/music/m31.mp3', musicposter: '/music/musicposter/m31.webp' },
  { id: 32, title: 'Lachar Lobhu.mp3', audio: '/music/music/m32.mp3', musicposter: '/music/musicposter/m32.webp' },
  { id: 33, title: 'VishwaGuru Banega Bharat.mp3', audio: '/music/music/m33.mp3', musicposter: '/music/musicposter/m33.webp' },
  { id: 34, title: 'Shant Prathna Geet.mp3', audio: '/music/music/m34.mp3', musicposter: '/music/musicposter/m34.webp' },
  { id: 35, title: 'Heart Like A Lotus.mp3', audio: '/music/music/m35.mp3', musicposter: '/music/musicposter/m35.webp' },
  { id: 36, title: 'Love Beyond Borders.mp3', audio: '/music/music/m36.mp3', musicposter: '/music/musicposter/m36.webp' },
  { id: 37, title: 'Find Your True Goal.mp3', audio: '/music/music/m37.mp3', musicposter: '/music/musicposter/m37.webp' },
  { id: 38, title: 'Light of the Soul.mp3', audio: '/music/music/m38.mp3', musicposter: '/music/musicposter/m38.webp' }
];



    useEffect(() => {
    const audio = audioRef.current;
    if (audio) {
      const updateTimer = () => setCurrentTime(audio.currentTime);
      const setTrackDuration = () => setDuration(audio.duration);
      audio.addEventListener('timeupdate', updateTimer);
      audio.addEventListener('loadedmetadata', setTrackDuration);

      return () => {
        audio.removeEventListener('timeupdate', updateTimer);
        audio.removeEventListener('loadedmetadata', setTrackDuration);
      };
    }
  }, [selectedTrack]);

  const formatTime = (time) => {
    const minutes = Math.floor(time / 60) || 0;
    const seconds = Math.floor(time % 60) || 0;
    return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
  };

  return (
    <div style={{ backgroundColor: 'black', minHeight: '100vh', padding: '20px', color: 'white' }}>
      {!selectedTrack ? (
        <>
          <h1 className="zone-title">🎵 Music Library</h1>
          <div className="episodes-grid">
            {tracks.map((track) => (
              <div key={track.id} className="episode-card" onClick={() => setSelectedTrack(track)}>
                <div className="episode-thumbnail">
                  <img src={track.musicposter} alt={track.title} className="music-poster" />
                  <span className="episode-number">🎶</span>
                  <span className="music-tooltip">{track.title}</span>
                </div>
                <p className="episode-title">{track.title}</p>
              </div>
            ))}
          </div>
          <Link to="/zones" className="back-button">⬅ Back to Museum Realms</Link>
        </>
      ) : (
        <div className="video-player-container">
          <h2>{selectedTrack.title}</h2>
         <audio
            ref={audioRef}
            controls
            autoPlay
            onEnded={() => setSelectedTrack(null)}
            style={{ width: '80%', maxWidth: '600px', margin: '20px 0' }}
            >
            <source src={selectedTrack.audio} type="audio/mp3" />
            Your browser does not support the audio element.
            </audio>

          <p>{formatTime(currentTime)} / {formatTime(duration)}</p>
          <button className="back-button" onClick={() => setSelectedTrack(null)}>⬅ Back to Music</button>
        </div>
      )}
    </div>
  );
}

export default Music;

